<ms-my-bets-print-title></ms-my-bets-print-title>
<div class="my-bets-print-header-username" [hidden]="isEpcotEnabled">
    <span>{{ UserName }}</span>
    <span>{{ sitecore.myBets_Print.UserId }}: {{ userID }}</span>
</div>

<div *ngFor="let betslipGroup of betslipGroups">
    <div class="my-bets-print__date-group-header">{{ betslipGroup.date | msMyBetsDateFormatter: false }}</div>
    <div class="cards">
        <ms-my-bets-betslip
            *ngFor="let betslip of betslipGroup.betslips; last as isLast"
            [betslip]="betslip"
            [myBetsListContext]="myBetsListContext"
            [isLast]="isLast">
        </ms-my-bets-betslip>
    </div>
</div>
